import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { deletePricingFileAPI } from "../../api/pricingFiles";

const DeleteModal = ({
  DeleteDetails,
  handelModal,
  modal,
  handleSetMutation,
}) => {
  const [loading, setLoading] = useState(false);
  const toggle = () => handelModal(!modal);
  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await deletePricingFileAPI(id);
      toast.success(response?.data?.message, {
        position: "top-center",
      });
      toggle();
      handleSetMutation();
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <li className="preview-item">
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader
            toggle={toggle}
            close={
              <button className="close" onClick={toggle}>
                {/* <Icon name="cross" /> */}
              </button>
            }
          >
            Delete Pricing File
          </ModalHeader>
          <ModalBody>
            <p className=" fw-bold fs-16px">
              Are you sure you want to delete this pricing file?
            </p>
            <div className=" w-100 d-flex justify-content-end">
              <Button color="white" onClick={toggle}>
                Cancel
              </Button>
              <Button
                color="danger"
                onClick={() => {
                  handleDelete(DeleteDetails?.id);
                }}
              >
                {loading ? <Spinner color="white" size="sm" /> : "Confirm"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </li>
    </div>
  );
};

export default DeleteModal;
